import { defineStore } from 'pinia'
import { useSystemStore } from './system'

// The conversation the drawer picks back up is scoped to the browser session, so a member
// can move around the hub, reopen the drawer and carry on where they left off.
const SESSION_KEY = 'aiAssistantConversationId'

export const useAiAssistantStore = defineStore('aiAssistant', {
  state: () => ({
    isDrawerOpen: false,
    conversationId: sessionStorage.getItem(SESSION_KEY) || null
  }),
  getters: {
    assistant() {
      return useSystemStore().hub?.ai_assistant || null
    },
    assistantId() {
      return useSystemStore().hub?.ai_assistant_id || null
    },
    hasCallToAction() {
      return Boolean(this.assistantId)
    },
    callToAction() {
      return this.assistant?.cta || 'Ask Me Anything'
    },
    callToActionColour() {
      return this.assistant?.cta_colour || '#309eaa'
    },
    callToActionTextColour() {
      return this.assistant?.cta_text_colour || '#FFFFFF'
    }
  },
  actions: {
    openDrawer() {
      this.isDrawerOpen = true
    },
    closeDrawer() {
      this.isDrawerOpen = false
    },
    setConversation(conversationId) {
      this.conversationId = conversationId

      if (conversationId) {
        sessionStorage.setItem(SESSION_KEY, conversationId)
      } else {
        sessionStorage.removeItem(SESSION_KEY)
      }
    },
    startNewConversation() {
      this.setConversation(null)
    }
  }
})
